<template>
    <el-button class="product-payment txtButtonAddBasket-paypal" @click="orderCreate"
       :loading="isLoading">{{ text }}
        <img :src="image" :alt="alternate"/></el-button>
</template>

<script>
    export default {
        props: {
            product: {
                type: Object,
                required: true,
            },
            text: {
                type: String,
                required: false,
            },
            image:{
                required: false,
            },
            alternate:{
                required: false,
            }
        },
        data() {
            // This component is not used anymore
            return {
                formData: {products:[]},
                paymentCreated: {},
                isLoading:  false
            }
        },
        methods: {
            orderCreate(e) {
                this.isLoading = true
                e.preventDefault()
                this.formData['products'].push({
                    id: this.product.id,
                    name: this.product.name,
                    quantity: 1,
                    comment: this.product.comment || ''
                })
                localStorage.removeItem("items")
                axios.post('/api/checkout-paypal', this.formData).then(response => {
                    this.paymentCreated = response.data;
                    this.isLoading = false
                    window.open(this.paymentCreated.url, 'popUpWindow')
                })
                    .catch(responseErrors => {
                        if (responseErrors.response) {
                            if (responseErrors.response.status === 301) {
                                return location.href = responseErrors.response.data.redirect
                            }
                        }
                    })
            },
        },
        mounted() {
        }
    }
</script>